import { Box, Typography, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HeaderBox = styled(Box)(({ theme }) => ({
  background: '#E7EFF5 !important',
  borderTop: '1px solid #D1D9E0',
  borderLeft: '1px solid #D1D9E0',
  borderRight: '1px solid #D1D9E0',
  borderBottom: '1px solid #D1D9E0',
  textAlign: 'center',
  padding: '8px 12px',
  width: '100%',
}));

export const HeaderBoxLeft = styled(HeaderBox)({
  borderTopLeftRadius: '4px',
});

export const HeaderBoxRight = styled(HeaderBox)({
  borderTopRightRadius: '4px',
});

export const HeaderTypography = styled(Typography)({
  fontSize: '12px',
  fontWeight: 700,
  color: '#063142',
  fontFamily: "'Lato', sans-serif",
});

export const IbrsLabelBox = styled(Box)({
  bgcolor: '#F3F4F6',
  borderLeft: '1px solid #E5E7EB',
  borderRight: '1px solid #E5E7EB',
  borderBottom: '1px solid #E5E7EB',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '40px',
  minHeight: '40px'
});

export const BulkyIbrsLabelBox = styled(IbrsLabelBox)({
  borderBottomLeftRadius: '4px'
});

export const SubLabelBox = styled(Box)({
  bgcolor: 'white',
  padding: '8px 16px',
  borderRight: '1px solid #E5E7EB',
  borderBottom: '1px solid #E5E7EB',
  display: 'flex',
  alignItems: 'center',
  height: '20px'
});

export const InputContainerBox = styled(Box)({
  bgcolor: 'white',
  padding: '4px 8px',
  borderRight: '1px solid #E5E7EB',
  borderBottom: '1px solid #E5E7EB',
  height: '20px',
  display: 'flex',
  alignItems: 'center'
});

export const LastInputContainerBox = styled(InputContainerBox)({
  borderBottomRightRadius: '4px'
});

export const IbrsTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    height: '32px',
    fontSize: '14px',
    '& fieldset': {
      border: 'none',
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: '8px 12px',
    textAlign: 'right',
  },
});

export const LabelTypography = styled(Typography)({
  fontWeight: 500,
}); 